import React from 'react';
import {MuseumListItem} from "./MuseumListItem";
import {List, Divider} from "@mui/material";

export const MuseumList = ({museums}) => {
    if(museums.length) {
        return (
            <>
                <Divider />
                <List>
                    {museums.map(museum => (
                        <MuseumListItem
                            key={museum.id}
                            museum={museum}
                        />
                    ))}
                </List>
            </>
        )
    } else {
        return null;
    }
}
